<template>
    <div class="container">
        <el-table
            border
            :header-cell-style="{
            'background-color': '#EFF3F6',
            'font-size': '14px',
            'color': '#000000',}"
            :data="entQualificationCertLevels">
            <el-table-column
                    label="资质大类"
                    align="center">
                <template scope="scope">
                    <span>{{scope.row.qualificationSerialName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="资质类型"
                    align="center">
                <template scope="scope">
                    <span>{{scope.row.qualificationProfessionalName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="资质等级"
                    align="center">
                <template scope="scope">
                    <el-select v-if="state == 4" v-model="scope.row.qualificationLevel" @change="qualificationLevelListEvent(scope.row,scope.$index)" :disabled="!!scope.row.qualificationSerial ? false : true" filterable size="small" clearable>
                        <el-option v-for="(item,index) in qualificationLevelList"
                                   :key="index"
                                   :label="item.text"
                                   :value="item.id+','+item.text">
                        </el-option>
                    </el-select>
                    <span v-else>
                        {{(scope.row.qualificationLevel && scope.row.qualificationLevel.split(',')[1]) || scope.row.qualificationLevelName}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="资质名称"
                    align="center">
                <template scope="scope">
                    <span>{{scope.row.qualificationName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    v-if="state == 4"
                    label="操作"
                    align="center"
                    width="80">
                <template scope="scope">
                    <span class="delBtn" type="primary" @click="delQualification(scope.$index)">删除</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        props: {
            entQualificationCertLevels:{
                type:Array
            },
            state:{
                type:Number
            }
        },
        data(){
            return {

            }
        },
        created(){
            this.$store.dispatch('dataDictionary/getQualificationLevelList');//获取资质等级
        },
        computed:{
            ...mapState({
                qualificationLevelList:(state) => state.dataDictionary.qualificationLevelList,
            })
        },
        methods:{
            delQualification(index){
                this.entQualificationCertLevels.splice(index,1);
            },
            qualificationLevelListEvent(row,index){
                let entQualificationCertLevelsAdd = [];
                this.entQualificationCertLevels.forEach((item,index)=>{
                    entQualificationCertLevelsAdd.push({
                        qualificationSerialName:item.qualificationSerialName,
                        qualificationSerial:item.qualificationSerial,
                        qualificationProfessionalName:item.qualificationProfessionalName,
                        qualificationProfessional:item.qualificationProfessional,
                        qualificationLevel:item.qualificationLevel,
                        qualificationName:item.qualificationName,
                    });
                })
                entQualificationCertLevelsAdd[index].qualificationSerialName = row.qualificationSerialName;//资质大类
                entQualificationCertLevelsAdd[index].qualificationSerial = row.qualificationSerial;//资质大类
                entQualificationCertLevelsAdd[index].qualificationProfessionalName = row.qualificationProfessionalName;//资质类型
                entQualificationCertLevelsAdd[index].qualificationProfessional = row.qualificationProfessional;//资质类型
                entQualificationCertLevelsAdd[index].qualificationLevel = row.qualificationLevel;//资质等级
                entQualificationCertLevelsAdd[index].qualificationName = row.qualificationSerialName+' ('+row.qualificationProfessionalName+(!!row.qualificationLevel ? row.qualificationLevel.split(',')[1] : '')+') '
                this.$emit('update:entQualificationCertLevels',entQualificationCertLevelsAdd);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .container{
        /deep/ .el-table{
                .el-table__header-wrapper tr th{
                    width: 221px;
                    height: 48px;
                    background: #FAFAFA;
                    font-size: 14px;
                    color: #000000;
                    line-height: 14px;
                }
                .el-table__header tr,
                .el-table__header th{
                    height: 48px;
                    padding: 0;
                }
                .el-table__body tr,
                .el-table__body td{
                    height: 48px;
                    padding: 0;
                }
                .el-input__inner{
                    width: 150px;
                }
                .delBtn{
                    cursor: pointer;
                    color: #409EFF;
                }
            }

        .qualification-add{
            .el-button{
                width: 100%;
            }
        }
    }
</style>